package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout

/** Shares project-bound resources with the editor while retaining a real gallery URL. */
@Page("/app/projects/{slug}/screenshots/templates")
@Layout(".components.layouts.AppLayout")
@Composable
fun ScreenshotTemplatesPage() { DesignWorkspace(templates = true) }
